import {SWITCH_LAYER} from './actions';

const DefaultState = {
  activeLayer: 'jscolor',
  layers: [
    {text: 'Mūsdienu karte', id: 'jscolor'},
    {text: 'Pirmskara karte', id: 'topo75'},
  ]
}

const baseLayers = (state = DefaultState, action) => {
  switch (action.type) {
    case SWITCH_LAYER:

      return Object.assign({}, state, {activeLayer: action.layer});
    default:
      return state;
  }
}

export {baseLayers}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/baseLayers/reducer.js